import { Logo } from 'components/Header/components/Logo'

import type { FC } from 'react'

export const PrintHeader: FC = () => (
  <header className="mb-4 hidden h-10 w-full justify-between gap-x-2 border-b border-inverse print:flex">
    <div className="flex items-baseline">
      <Logo />
    </div>
  </header>
)
